
export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'module_grid_filter';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	this.addEvents( true );

        console.log('initModuleGridFilter');
        console.log(this.$el[0]);


    	// if ( this.$el.parent().hasClass( 'wrap-select' ) ){
    	// 	this.labelSkin = true;
    	// 	this.$label = this.$el.parent().find( 'label' );
    	// 	this.setLabel();
    	// }
	}

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		// if ( b ){
		// 	this.$el.on( 'change', () => this.onChange() );
		// }
		// else{
		// 	this.$el.off( 'change', () => this.onChange() );
		// }
	}

	onChange(){
        // let url = this.$el.val();
        // this.setLabel();
        // this.main.barba_triggerURL( url, this.$el );
 	}

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
		if ( this.$el.length > 0 ){
    		this.addEvents( false );
    	}
    }

}


